
<!-- <div class="bn-notice-content" *ngIf="policy">
    <app-bn-notice [policy]="policy"></app-bn-notice>
</div> -->
<div class="bn-checking-savings-pay margin-bottom mb32" *ngIf="!showConfirmComponent && (policy?.billingDetails[0]?.outstandingbalance !== 0 || policy?.billingDetails[0]?.priorYearBalance > 0)">
    <form [formGroup]="newPaymentForm" name="newPaymentForm" (ngSubmit)="
      newPaymentRadioForm.valid && newPaymentForm.valid && newPaymentFormSubmit()
    ">
        <section class="row radio-amount" [formGroup]="newPaymentRadioForm">
            <div class="col">
                <div class="bn-mkpay-title bn-lh-32" [ngClass]="{'dm-sans-medium': !isAcmic}">
                    {{ "SELECT_AMOUNT" | translate }}
                </div>
                <hr class="thin-hr margin-top mt8 margin-bottom mb24">
                <div class="row">
                    <div class="col mk-col-auto">
                        <div class="radio-label bn-makepay-min-amt">
                            <input class="" type="radio" id="paymentAmount-minimum" name="paymentAmount"
                                formControlName="paymentAmount" [value]="currentMinAmtDue" [required]="true" 
                                (change)="OnChangeShowCustomAmountField('paymentAmount-minimum');setDynamicInputValidation('paymentAmount-minimum')" />
                            <label class="no-margin-bottom align-top no-margin-left" for="paymentAmount-minimum">
                                <div class="bn-selct-amt-sec">
                                    <div class="bn-secondary-title">{{ "Min amount due" | translate }} </div>
                                    <div class="bn-payment-minamt" [ngClass]="{'margin-top mt8':isAcmic}">
                                        {{ currentMinAmtDue | currency }}
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>

                </div>
                <div class="row margin-top mt24">
                    <div class="col mk-col-auto mkpay-other-opt">
                        <div class="radio-label pl-3">
                            <input class="" type="radio" id="paymentAmount-max" name="paymentAmount"
                                formControlName="paymentAmount" [value]="outstandingBalance" [required]="true" (change)="
                  OnChangeShowCustomAmountField('paymentAmount-max');
                  setDynamicInputValidation('paymentAmount-max')
                " />
                            <label class="no-margin-bottom align-top no-margin-left" for="paymentAmount-max">
                                <div class="bn-selct-amt-sec">
                                    <div class="bn-secondary-title">{{"OUTSTANDING_BALANCE" | translate}}*</div>
                                    <div class="bn-payment-outstand-bal">
                                        {{ outstandingBalance | currency }}
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>

                </div>
                <div class="row margin-top mt24" [ngClass]="{'mt32': isAcmic}">
                    <div class="col mk-col-auto  mkpay-other-opt height ">
                        <div class="radio-label pl-3 mkpay-amt-options" [ngClass]="{'custom-radio-btn-aligment':showCustomAmount || isAcmic,'radio-btn-top-align':!showCustomAmount && isAcmic}">
                            <input class="" type="radio" id="paymentAmount-other" name="paymentAmount"
                                formControlName="paymentAmount" value="other" [required]="true" (change)="
                  OnChangeShowCustomAmountField('other');
                  

                " />
                            <label class="no-margin-bottom align-top no-margin-left" for="paymentAmount-other">
                            </label>
                            <div class="bn-selct-amt-sec height-auto">
                                <div class="bn-secondary-title">{{ "OTHER_AMOUNT" | translate }}</div>
                                <div class="other-amount" *ngIf="showCustomAmount">
                                    <div class="input-content">
                                        <div class="input-field mapfre">
                                            <input formControlName="otherAmount" id="otherAmount" name="otherAmount"
                                                type="text" required="true" (keyup)="checkAmountNow($event)"
                                                (focus)="enterAmount($event)" (focusout)="enterAmount($event)" />
                                            
                                        </div>
                                        <div class="help-block error-block" *ngIf="
                                newPaymentRadioForm.controls.otherAmount.errors?.pattern
                                  ?.actualValue;
                                else minOrMax
                              ">
                                            {{ "NOT_IN_A_VALID_FORMAT" | translate }}
                                        </div>
                                        <ng-template #minOrMax>
                                            <div class="help-block error-block"
                                                *ngIf="newPaymentRadioForm.controls.otherAmount.errors?.min?.min">
                                                {{ "THIS_AMOUNT_IS_GREATER_THAN_ONE" | translate }}
                                            </div>
                                            <div class="help-block error-block"
                                                *ngIf="newPaymentRadioForm.controls.otherAmount.errors?.max?.max">
                                                {{ "THIS_AMOUNT_IS_GREATER_THAN_OUTSTANDING" | translate }}
                                                {{ policy?.billingDetails[0]?.outstandingbalance | currency }}
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="row bank-inputs margin-top mt32">
            <div class="col">
                <ng-container *ngIf="isAcmic; else MAStateNewPaymentMK">
                    <div class="bn-mkpay-title">
                        {{ "Checking/savings account" | translate }}
                        <ng-container *ngIf="storeBankAccount?.accountHolderName">
                            <mapfre-button
                                additionalClasses="link-button blue-link float-right no-border text-capitalize no-padding edit-account-button"
                                (click)="OnClickEditButton()">
                                <span class="lh-19">{{ "EDIT" | translate }}</span>
                                <img src="assets/img/images/icon-edit-acmic-24.svg" width="20" height="20" alt="edit icon" class="margin-left ml4"/>
                            </mapfre-button>
                        </ng-container>
                    </div>
                    <hr class="thin-hr margin-top mt8 margin-bottom mb24">
                </ng-container>
                <ng-template #MAStateNewPaymentMK>
                    <div class="bn-mkpay-title dm-sans-medium">
                        {{ "Checking/savings account" | translate }}
                        <ng-container *ngIf="storeBankAccount?.accountHolderName">
                            <mapfre-button
                                additionalClasses="link-button red-link float-right no-border no-padding edit-account-button"
                                (click)="OnClickEditButton()">
                                <div class="lh-21">{{ "EDIT" | translate }}</div>
                                <img src="./assets/img/images/icon-edit-red.svg" alt="edit icon" width="16" height="16" class="margin-left ml4" />
                            </mapfre-button>
                        </ng-container>
                    </div>
                    <hr class="thin-hr margin-top mt8 margin-bottom mb16">
                </ng-template>

                <ng-container *ngIf="!loading">
                    <ng-container *ngIf="editAccount || !storeBankAccount?.accountHolderName">
                        <div class="checking-form newPaymentFields">
                            <div *ngIf="((policy?.policynumber?.policyNumber?.length === 10 && policy?.jurisdiction?.state === 'MA') || isAcmic)">
                                <p class="account-type-radio-heading">Account type</p>
                                    <mapfre-validation
                                        [input]="accountTypeInput"
                                        [form]="newPaymentRadioForm">
                                    </mapfre-validation>
                            </div>
                            <div *ngFor="let input of inputs | slice:0:4; index as i" class="input">
                                <mapfre-validation [input]="input" [form]="newPaymentForm" [maximumLength]="9"></mapfre-validation>
                            </div>
                            <div>
                                <div>
                                    <div *ngFor="let input of inputs | slice: 4; index as i" class="input">
                                        <ng-container *ngIf="input.inputType === 'checkbox' && isEFT !== 'ENROLLED'">
                                            <div class="margin-bottom mb24 default-checkbox-label" [ngClass]="{'green-checkbox-border':storeCheck}">
                                                <input type="checkbox" class="single-checkbox" id="store-checkbox"
                                                    (change)="getStoreAccountInfo($event)" />
                                                <label class="margin-left ml16 no-margin-bottom bn-store-label" for="store-checkbox">
                                                   <span class="lh-19" [ngClass]="{'lh-20':!isAcmic}"> {{
                                                    input.label | translate }} </span></label>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="input.inputType !== 'checkbox' && input.inputType !== 'select' && !(input?.key === 'newPayment_checkNumber' && newPaymentRadioForm.controls['accountType'].value === 'SAVINGL')">
                                            <mapfre-validation [input]="input" [form]="newPaymentForm" [maximumLength]="9"
                                                >
                                            </mapfre-validation>
                                            <label class="custom_label check_custom" *ngIf="input?.key === 'newPayment_aptNumber'" 
                                                [ngClass]="{ hide: policyId?.length === 10 }">{{ "OPTIONAL" | translate }}
                                            </label>
                                        </ng-container>
                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="storeBankAccount?.accountHolderName && !editAccount">
                        <div class="checking-info margin-top mt24">
                            <div class="row  margin-bottom mb24">
                                <div class="col">
                                    <div class="bn-acc-title margin-bottom mb4" [ngClass]="{'mb8':isAcmic}">{{ "Account holder’s name" | translate }}</div>
                                    <div class="bn-acc-val">{{ storeBankAccount?.accountHolderName | titlecase}}</div>
                                </div>
                            </div>
                            <div class="row margin-bottom mb24">
                                <div class="col">
                                    <div class="bn-acc-title margin-bottom mb4" [ngClass]="{'mb8':isAcmic}">{{ "ACCOUNT_NUMBER" | translate }}</div>
                                    <div class="bn-acc-val">{{ storeBankAccount?.accountNumber.digits | maskAccountNumber }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [formGroup]="newPaymentForm">
                            <ng-container *ngFor="let input of inputs">
                                <div class="col input-content" *ngIf="input?.key === 'newPayment_checkNumber' && newPaymentRadioForm.controls['accountType'].value !== 'SAVINGL'" [ngClass]="{'unedit-sec': isAcmic}">
                                    <mapfre-validation [input]="input" [form]="newPaymentForm">
                                    </mapfre-validation>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <div class="col">
                        <div class="row bn-payment-action-sec" [ngClass]="{'form-valid-btn':(newPaymentRadioForm.valid &&
                        newPaymentForm.valid &&!loader) || (newPaymentRadioForm.valid && newPaymentForm.valid &&checkAmount &&!loader)}">
                            
                            <div class="bn-make-pay-btn-container">
                                <div class="btn-margin-mobile">
                                    <mapfre-button additionalClasses="ghost secondary bn-payment-action-btn mr-3"
                                        (click)="showLandingPageOnCancel()">
                                        {{ "CANCEL" | translate }}
                                    </mapfre-button>
                    
                                </div>
                            </div>
                            <div class="bn-make-pay-btn-container">
                                <div *ngIf="showCustomAmount; else showAmount">
                                    <mapfre-button [ngClass]="{ custom_loader: loader }"
                                        additionalClasses="basic primary bn-payment-action-btn no-margin" [disabledValue]="newPaymentRadioForm.valid &&
                                                    newPaymentForm.valid &&
                                                    checkAmount &&
                                                    !loader" [inputType]="'submit'" [translateValue]="'CONTINUE' | translate">
                                    </mapfre-button>
                                </div>
                                <ng-template #showAmount>
                                    <div>
                                        <mapfre-button [ngClass]="{ custom_loader: loader }"
                                            additionalClasses="basic primary bn-payment-action-btn no-margin" [disabledValue]="
                                                        newPaymentRadioForm.valid &&
                                                        newPaymentForm.valid &&
                                                        !loader" [inputType]="'submit'" [translateValue]="'CONTINUE' | translate">
                                        </mapfre-button>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </section>
    </form>
</div>
<div *ngIf="showConfirmComponent">
    <app-bn-confirm-payment [policy]="policy" (showPaymentEntryScreen)="showPaymentEntryScreen()"></app-bn-confirm-payment>
</div>